import { render } from "./RecentProjects.vue?vue&type=template&id=9ed36c02"
import script from "./RecentProjects.vue?vue&type=script&lang=js"
export * from "./RecentProjects.vue?vue&type=script&lang=js"

import "./RecentProjects.vue?vue&type=style&index=0&id=9ed36c02&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__